import {clsx} from 'clsx';
import React, {useCallback} from 'react';

import {Tailwind} from '../../../../../../Tailwind';
import {MessageEditor} from '../../../prompts/MessageEditor';
import {MessageVariables} from '../../../prompts/MessageVariables';
import {MessageList} from '../../ChatView/MessageList';
import {Message, Messages} from '../../ChatView/types';
import {PlaygroundContext} from '../../PlaygroundPage/PlaygroundContext';

type TabPromptProps = {
  messages: Messages;
  setMessages: (messages: Messages) => void;
  isEditing: boolean;
};

export const TabPrompt = ({
  messages,
  setMessages,
  isEditing,
}: TabPromptProps) => {
  const addMessage = useCallback(
    (newMessage: Message) => {
      setMessages([...messages, newMessage]);
    },
    [messages, setMessages]
  );

  const editMessage = useCallback(
    (messageIndex: number, newMessage: Message) => {
      setMessages(
        messages.map((msg: Message, idx: number) =>
          idx === messageIndex ? newMessage : msg
        )
      );
    },
    [messages, setMessages]
  );

  const deleteMessage = useCallback(
    (messageIndex: number, responseIndexes?: number[]) => {
      setMessages(
        messages.filter((_: any, idx: number) => idx !== messageIndex)
      );
    },
    [messages, setMessages]
  );

  return (
    <Tailwind>
      <div className="flex flex-col sm:flex-row">
        <div className={clsx('mt-4 w-full')}>
          {/* Variables Section */}
          <MessageVariables messages={messages} />

          {/* Message Display/Editing */}
          {!isEditing ? (
            <PlaygroundContext.Provider
              value={{
                isPlayground: false,
                isStreaming: false,
                addMessage,
                editMessage,
                deleteMessage,
                // TODO: Consider making below optional
                editChoice: (_choiceIndex, _newChoice) => {},
                deleteChoice: (_messageIndex, _choiceIndex) => {},
                sendMessage: (_role, _content, _toolCallId) => {},
                cancelGeneration: () => {},
                setSelectedChoiceIndex: _choiceIndex => {},
                isMarkdownEnabled: false,
                setIsMarkdownEnabled: () => {},
              }}>
              <MessageList messages={messages} alwaysShowButtons={false} />
            </PlaygroundContext.Provider>
          ) : (
            <MessageEditor messages={messages} setMessages={setMessages} />
          )}
        </div>
      </div>
    </Tailwind>
  );
};
